// extracted by mini-css-extract-plugin
var _1 = "TopicView-module__animateUploadProgressBarWidth--m0YxY";
var _2 = "TopicView-module__animatedBackground--mlrfW";
var _3 = "TopicView-module__container--CNtlH";
var _4 = "TopicView-module__isEditing--mp646";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "isEditing" }
